export const wordTwo = [
  {
    id: 1,
    text: "Doctor",
    response:
      "National Doctor’s day is celebrated on July 1 to mark the birth of Dr. Chandra Roy.",
  },
  {
    id: 2,
    text: "Positive",
    response: "Positive attitude leads to positive outcomes.",
  },
  {
    id: 3,
    text: "HIV",
    response: "Practicing safe sex is the key to preventing HIV.",
  },
  {
    id: 4,
    text: "Patient",
    response: "Being patient enhances endurance.",
  },
  {
    id: 5,
    text: "Virus",
    response: "Masks, hygiene, and social distancing reduce virus transmission",
  },
  {
    id: 6,
    text: "Knowledge",
    response: "Curiosity leads to the quest of knowledge.",
  },
  {
    id: 7,
    text: "Lockdown",
    response:
      "Lockdowns are an effective way of controlling the spread of Covid in communities.",
  },
  {
    id: 8,
    text: "Tackle",
    response: "Tackle adversity with determination and perseverance.",
  },
  {
    id: 9,
    text: "Uniform",
    response: "Uniform portrays equality.",
  },
  {
    id: 10,
    text: "Family",
    response: "Family and friends are the unnoticed wealth of human’s life.",
  },
  {
    id: 11,
    text: "Aware",
    response:
      "We must raise public awareness about Environment and Climate change. ",
  },
  {
    id: 12,
    text: "Future",
    response: "Future is decided by the choices we make today.",
  },
  {
    id: 13,
    text: "Medicine",
    response: "Ancient Indian medicines are being widely accepted.",
  },
  {
    id: 14,
    text: "Happy",
    response: "Happiness is self defined.",
  },
  {
    id: 15,
    text: "Operation",
    response:
      "India has a huge participation of soldiers in UN peacekeeping operations.",
  },
  {
    id: 16,
    text: "Disobey",
    response: "Balck hole disobeys laws of Physics.",
  },
  {
    id: 17,
    text: "Diminish",
    response: "Human eyesight diminish with age.",
  },
  {
    id: 18,
    text: "Overcome",
    response: "Self confidence overcomes nervousness.",
  },
  {
    id: 19,
    text: "Episode",
    response:
      "A brief episode in life should be devoted to family and friends.",
  },
  {
    id: 20,
    text: "Haunt",
    response: "Ignoring our problems haunts us back.",
  },
  {
    id: 21,
    text: "Impulsive",
    response: "One must learn to control their impulsive behavior.",
  },
  {
    id: 22,
    text: "Clock",
    response: "Wars and riots turn back the clock on years of progress.",
  },
  {
    id: 23,
    text: "Sacrifice",
    response: "One must not sacrifice personal life for the sake of career.",
  },
  {
    id: 24,
    text: "Monk",
    response: "A monk thinks beyond the material world.",
  },
  {
    id: 25,
    text: "Marriage",
    response: "LGBTQ laws have legalised the same-sex marraige.",
  },
  {
    id: 26,
    text: "Dream",
    response: "One must overcome fear for their dreams.",
  },
  {
    id: 27,
    text: "Health",
    response: "Healthy people perform better.",
  },
  {
    id: 28,
    text: "Decent",
    response: "One must be decent and hardworking in their behavior.",
  },
  {
    id: 29,
    text: "Imagination",
    response: "Imagination transcends limitation.",
  },
  {
    id: 30,
    text: "Strong",
    response: "Great teams are built by strong leaders.",
  },
  {
    id: 31,
    text: "Team-Work",
    response: " Effective management is a result of good teamwork.",
  },
  {
    id: 32,
    text: "Strict",
    response: "Strict laws ensure safe society.",
  },
  {
    id: 33,
    text: "Ambassador",
    response: "Ambassador was the first diesel engine car in India.",
  },
  {
    id: 34,
    text: "Beauty",
    response: "Tricolor is a beauty to millions.",
  },
  {
    id: 35,
    text: "Cryptocurrency",
    response: "It is the decentralized form of currency.",
  },
  {
    id: 36,
    text: "Practical",
    response: "One must have a practical approach to problems.",
  },
  {
    id: 37,
    text: "Money",
    response: "Time is the biggest dividend money can buy.",
  },
  {
    id: 38,
    text: "Luxury",
    response: "Luxury items are under highest tax slap under GST.",
  },
  {
    id: 39,
    text: "Cute",
    response: "Smiles enhance cuteness.",
  },
  {
    id: 40,
    text: "Art",
    response: "Every excellency is an art.",
  },
  {
    id: 41,
    text: "Book",
    response: "Books offer a variety of perspectives on life.",
  },
  {
    id: 42,
    text: "Technology",
    response: "Advancement in medical technology have saved countless lives.",
  },
  {
    id: 43,
    text: "Light",
    response: "Light is the fastest travelling entity in the universe.",
  },
  {
    id: 44,
    text: "Insensitive",
    response: "An insensitive bureaucracy is the root cause of corruption.",
  },
  {
    id: 45,
    text: "Contract",
    response: "We are bound by moral contract to preserve the public property.",
  },
  {
    id: 46,
    text: "Depend",
    response: "Capital economy completely depend on market.",
  },
  {
    id: 47,
    text: "Avenge",
    response: "Avenger is the highest-grossing movie of all time.",
  },
  {
    id: 48,
    text: "Battle",
    response:
      "Thousands of soldiers are willing to go into battle for the country.",
  },
  {
    id: 49,
    text: "Alert",
    response: "Cities and hospitals were on red alert during Covid outbreak.",
  },
  {
    id: 50,
    text: "Gallant",
    response:
      "The Ashoka Chakra is the highest peacetime military gallantry award.",
  },
  {
    id: 51,
    text: "Bribe",
    response: "Bribery damages the work ethics.",
  },
  {
    id: 52,
    text: "Compel",
    response: "Public opinion compels the government decision.",
  },
  {
    id: 53,
    text: "Extraordinary",
    response: "Extraordinary achievements require extraordinary efforts.",
  },
  {
    id: 54,
    text: "Humor",
    response: "A good sense of humor is an attractive quality.",
  },
  {
    id: 55,
    text: "Rigid",
    response: "Diamond has extraordinary rigidity.",
  },
  {
    id: 56,
    text: "Sexual",
    response: "Teenagers must be taught about sexual abuse.",
  },
  {
    id: 57,
    text: "Carelessness",
    response: "Carelessness leads to procrastination.",
  },
  {
    id: 58,
    text: "All",
    response:
      "Operation Vijay was the greatest victory of all time by our Armed forces.",
  },
  {
    id: 59,
    text: "Not",
    response: "Out of 195 countries only 2 are not the member of the UN.",
  },
  {
    id: 60,
    text: "Odd",
    response:
      "The odd-even scheme is an effective way to control vehicular pollution.",
  },
];
